import { Component } from '@angular/core';

@Component({
  selector: 'kChangelogContent',
  templateUrl: './changelog-content.component.html',
  styleUrls: ['./changelog-content.component.scss'],
})
export class ChangelogContentComponent {}
